module.exports = __webpack_public_path__ + "img/giro.deb1005a.svg";